<div class="file-outdated-modal">
  <div class="modal-content">
    <div class="warning-icon mb-3">
      <i class="pi pi-exclamation-circle text-warning" style="font-size: 2.5rem"></i>
    </div>

    <h4 class="mb-3">Loan File Has Been Modified</h4>

    <p class="text-muted mb-4">
      The loan file {{ loanNumber }} has been modified by {{ modifiedBy }}. Your current view may contain outdated information.
    </p>

    <p class="text-muted mb-4">
      <strong>Refresh</strong> to load the latest changes, or <strong>Continue Editing</strong> to keep your current view (your changes may overwrite
      the other user's changes when saved).
    </p>

    <div class="d-flex justify-content-center gap-2">
      <button pButton type="button" (click)="refresh()" class="p-button-primary">
        <i class="pi pi-refresh me-2"></i>
        Refresh
      </button>
      <button pButton type="button" (click)="continueEditing()" class="p-button-secondary">Continue Editing</button>
    </div>
  </div>
</div>
